import { useFormField } from '@calendly/form';
import classNames from 'classnames';
import { forwardRef } from 'react';
import ErrorMessage from 'components/core/error_message';
import Avatar from './avatar';
import { FullStoryExclude } from '../../../../shared/fullstory_privacy';
const inlineErrorMessageCss = "ixzld4w";
const InlineErrorMessage = forwardRef((props, ref) => <ErrorMessage ref={ref} {...props} className={classNames(inlineErrorMessageCss, props.className)} />);
function getAvatar({
  remove,
  preview,
  url
}) {
  if (remove) {
    return null;
  }
  return preview || url;
}
export const AvatarField = ({
  validate
}) => {
  const [{
    value
  }, meta, {
    setValue,
    setTouched,
    setError
  }] = useFormField({
    name: 'avatar'
  });
  const onAvatarRemove = () => {
    setValue({
      remove: true
    });
    setTouched(true);
  };
  const onFileSelect = ({
    file,
    cropData,
    previewDataUrl
  }) => {
    setError(); // candidate file was accepted, reset inline errors
    setValue({
      file,
      crop: cropData,
      preview: previewDataUrl
    });
    setTouched(true);
  };
  const onFileError = errorMessage => {
    setError(errorMessage);
    setTouched(false);
  };
  return <FullStoryExclude>
      <Avatar avatar={getAvatar(value)} onAvatarRemove={onAvatarRemove} onFileSelect={onFileSelect} onFileError={onFileError} validate={validate} />
      {meta.error && <InlineErrorMessage message={meta.error} />}
    </FullStoryExclude>;
};

require("./avatar-field.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./avatar-field.js");